"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TankApi = exports.TankApiFactory = exports.TankApiFp = exports.TankApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
const common_1 = require("../common");
const base_1 = require("../base");
const TankApiAxiosParamCreator = function (configuration) {
    return {
        esyoilAPIEntryPointsTankDeleteTank: async (options = {}) => {
            const localVarPath = `/v1/tank/delete`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsTankGetTankInformation: async (options = {}) => {
            const localVarPath = `/v1/tank/get`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsTankUpdateTankInformation: async (volume, volumeLimit, inactive, shape, height, yearlyUsage, hotWater, options = {}) => {
            const localVarPath = `/v1/tank/update`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (volume !== undefined) {
                localVarFormParams.set('volume', volume);
            }
            if (volumeLimit !== undefined) {
                localVarFormParams.set('volume_limit', volumeLimit);
            }
            if (inactive !== undefined) {
                localVarFormParams.set('inactive', inactive);
            }
            if (shape !== undefined) {
                localVarFormParams.set('shape', shape);
            }
            if (height !== undefined) {
                localVarFormParams.set('height', height);
            }
            if (yearlyUsage !== undefined) {
                localVarFormParams.set('yearly_usage', yearlyUsage);
            }
            if (hotWater !== undefined) {
                localVarFormParams.set('hot_water', hotWater);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TankApiAxiosParamCreator = TankApiAxiosParamCreator;
const TankApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TankApiAxiosParamCreator(configuration);
    return {
        async esyoilAPIEntryPointsTankDeleteTank(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsTankDeleteTank(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsTankGetTankInformation(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsTankGetTankInformation(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsTankUpdateTankInformation(volume, volumeLimit, inactive, shape, height, yearlyUsage, hotWater, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsTankUpdateTankInformation(volume, volumeLimit, inactive, shape, height, yearlyUsage, hotWater, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.TankApiFp = TankApiFp;
const TankApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TankApiFp(configuration);
    return {
        esyoilAPIEntryPointsTankDeleteTank(options) {
            return localVarFp.esyoilAPIEntryPointsTankDeleteTank(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsTankGetTankInformation(options) {
            return localVarFp.esyoilAPIEntryPointsTankGetTankInformation(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsTankUpdateTankInformation(volume, volumeLimit, inactive, shape, height, yearlyUsage, hotWater, options) {
            return localVarFp.esyoilAPIEntryPointsTankUpdateTankInformation(volume, volumeLimit, inactive, shape, height, yearlyUsage, hotWater, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TankApiFactory = TankApiFactory;
class TankApi extends base_1.BaseAPI {
    esyoilAPIEntryPointsTankDeleteTank(options) {
        return exports.TankApiFp(this.configuration).esyoilAPIEntryPointsTankDeleteTank(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsTankGetTankInformation(options) {
        return exports.TankApiFp(this.configuration).esyoilAPIEntryPointsTankGetTankInformation(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsTankUpdateTankInformation(volume, volumeLimit, inactive, shape, height, yearlyUsage, hotWater, options) {
        return exports.TankApiFp(this.configuration).esyoilAPIEntryPointsTankUpdateTankInformation(volume, volumeLimit, inactive, shape, height, yearlyUsage, hotWater, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TankApi = TankApi;
//# sourceMappingURL=tank-api.js.map